export default __webpack_public_path__ + "static/media/rosterSpots.dc9d5f48.jpg";